angular
    .module('MyApp')
    .service('ProjetosService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {

      this.listarProjetos = function(codPessoa, tipoProjeto){
        let deferr = $q.defer();
        if (codPessoa && tipoProjeto) {
          let defer = $q.defer();
            $resource(Configs.getApiServer() + '/edital/projetos?codPessoa=:codPessoa&tipoProjeto=:tipoProjeto',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  codPessoa, tipoProjeto
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    defer.reject();
                });
        return deferr.promise;
      } else {
        deferr.resolve(false);
      }
      return deferr.promise;
      }

      this.uploadDocumentoPessoa = function(data) {
        let deferr = $q.defer();
        if (data) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/pessoas/upload_documento_pessoa", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(data, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }

      this.incluirSolicitacaoRecurso = function(projetoPesquisaDTO) {
        let deferr = $q.defer();
        if (projetoPesquisaDTO) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/edital/solicita-recurso", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(projetoPesquisaDTO, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }

      this.anexarRelatorio = function(relatorioDTO) {
        let deferr = $q.defer();
        if (relatorioDTO) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/edital/anexa-relatorio", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(relatorioDTO, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }

      this.listarTermosCompromisso = function(idProjeto){
        let deferr = $q.defer();
         if (idProjeto) {
            $resource(Configs.getApiServer() + '/edital/termo-compromisso?id-projeto=:idProjeto',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idProjeto
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.aceitarTermoCompromisso = function(idTermo) {
        let deferr = $q.defer();
         if (idTermo) {
            $resource(Configs.getApiServer() + '/edital/aceita-termo-compromisso?id-termo=' + idTermo,
                {}, { 'query': { method: 'POST', isArray: false } }).query({
                  idTermo
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

    }]);
